module.exports = __webpack_public_path__ + "static/anne-pitman-workshops-7a3f7c8784af69e95ffe5c23f5d8d82f.jpg";